import React from "react";
import MinimalPublicPage from "./MinimalPublicPage";

export default function HowItWorksPage() {
  return (
    <MinimalPublicPage
      eyebrow="How it works"
      title="Sign in. Verify. Queue."
      description="Ouro keeps the path short: join with Steam, complete review, then play with people who passed the same bar."
      points={[
        {
          title: "Join with Steam",
          body: "Steam OpenID is read-only. Ouro never asks for inventory, trade, or market permissions.",
        },
        {
          title: "Get reviewed",
          body: "Human review on every signup keeps throwaway accounts and bad actors away from the queue. ID checks are optional.",
        },
        {
          title: "Play cleaner matches",
          body: "Queue windows, region controls, and reputation make solo games less random.",
        },
      ]}
      secondaryLabel="Pricing"
      secondaryTo="/pricing"
    />
  );
}
